import { PageMessageService } from '../services/page-message-service';
import { WebApiService } from '../services/web-api-service';
import { DefaultValidationRenderer } from "../resources/renderers/default-validation-renderer";
import { activationStrategy, Router } from 'aurelia-router';

import { newInstance, autoinject } from 'aurelia-framework';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { DialogService } from 'aurelia-dialog';
import { SimpleDialog } from './dialogs/simple-dialog';


@autoinject()
export class RegisterUser {

    constructor(
        private dialogService: DialogService,
        private router: Router,
        private pageMessageService: PageMessageService,
        @newInstance() private controller: ValidationController,
        private api: WebApiService) {

        this.controller.validateTrigger = validateTrigger.change;
        controller.addRenderer(new DefaultValidationRenderer());

    }

    email: string;

    register() {
        this.pageMessageService.clear();
        if (this.email && this.email.toLocaleLowerCase().indexOf("@nucor.com") > -1) {
            this.pageMessageService.setErrorMessage("Users with a `nucor.com` email address should use the SSO option to log in a request a user account.");
            return;
        }
        return this.api.post("Auth", "Register", { email: this.email })
            .then(result => {
                var user = JSON.parse(result.response);

                this.dialogService.open({
                    viewModel: SimpleDialog,
                    model: {
                        title: "Registration Successful",
                        icon: "fa-exclamation-triangle",
                        message: "A welcome email with login instructions has been sent to " + this.email + ".\n\nClick OK to configure roles for this user.",
                        buttons: ["Ok"]
                    }
                })

                .whenClosed((result) => {
                    if (!result.wasCancelled) {
                        if (result.output == "Ok") {
                            this.router.navigateToRoute("user-admin", { user_id: user.id });
                        }
                    }
                });
            },
                e => this.pageMessageService.setErrorMessage("Registration failed: " + e.errorMessage)
            )
    }
}


ValidationRules
    .ensure((m: RegisterUser) => m.email).required()
    .on(RegisterUser);
